import { useMutation } from 'react-query';
import { submitPCPRequest } from 'utils/submit-pcp-request';
import type { PCPSubmissionInfo } from 'utils/pcp-fhir-submission';

export const useSubmitPCPRequest = () =>
  useMutation(
    ({
      info,
      config,
    }: {
      info: PCPSubmissionInfo;
      config: { campaignId: string; activityId: string };
    }) => submitPCPRequest(info, config),
  );
